import { useState } from "react";
import { Pencil } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";

export const EditCustomerNameButton = ({ job, onSaved }) => {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put(`/jobs/${job.id}`, { customer_name: name.trim() });
      onSaved(data);
      toast.success("Customer name updated");
      setOpen(false);
    } catch (e) {
      toast.error(apiError(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Button variant="outline" size="sm" data-testid="edit-customer-name-btn"
        onClick={() => { setName(job.customer_name || ""); setOpen(true); }}>
        <Pencil className="mr-1.5 h-3.5 w-3.5" /> Edit name
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-md" data-testid="edit-customer-name-dialog">
          <DialogHeader>
            <DialogTitle>Correct customer name</DialogTitle>
            <DialogDescription>
              WhatsApp shows the name the customer set on their profile. Enter their real name — it updates the
              customer everywhere (jobs, inbox, slot chart).
            </DialogDescription>
          </DialogHeader>
          <div>
            <Label>Customer name</Label>
            <Input className="mt-1.5" value={name} onChange={(e) => setName(e.target.value)}
              data-testid="edit-customer-name-input" autoFocus />
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} data-testid="edit-customer-name-cancel">Cancel</Button>
            <Button onClick={save} disabled={busy || !name.trim() || name.trim() === job.customer_name}
              data-testid="edit-customer-name-save">{busy ? "Saving…" : "Save"}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
